/* Street Garms SG-048 — compact header treatment retained; legacy experiment tracking retired on Theme 88. */
(function () {
  'use strict';
  document.documentElement.setAttribute('data-sg048-experiment', 'SG-048');
})();
